export function childHomeTabAfterLogin(roleCode: 'guardian' | 'child'): 'chores' | null {
  return roleCode === 'child' ? 'chores' : null;
}
